import React from 'react';
import { Box, Button } from '@mui/material';
import {
    CloseRounded,
    DeleteFilledRounded,
    DoorOpenFilledOutlined,
    EditRounded
} from "@mui-symbols-material/w300";
import {useTranslation} from "react-i18next";


interface Props {
    isEditMode: boolean;
    onToggleEdit: () => void;
    onAddDoor: () => void;
    onDeleteGrid: () => void;
}

const GridHeader = ({ isEditMode, onToggleEdit, onAddDoor, onDeleteGrid }: Props) => {
    const {t} = useTranslation();

    return (
        <Box display="flex" justifyContent="flex-end" p={2}>
            {isEditMode &&
                <Button
                    startIcon={<DeleteFilledRounded />}
                    onClick={onDeleteGrid}
                    sx={{mr: "8px"}}
                >
                    {t("Delete grid")}
                </Button>
            }
            {isEditMode &&
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onAddDoor}
                    startIcon={<DoorOpenFilledOutlined />}
                    sx={{mr: "8px"}}
                >
                    {t("Add door")}
                </Button>
            }
            <Button
                variant="outlined"
                onClick={onToggleEdit}
                startIcon={isEditMode ? null : <EditRounded />}
                sx={isEditMode ? {p: "10px"} : {}}
            >
                {isEditMode ? <CloseRounded /> : t('Edit')}
            </Button>
        </Box>
    );
};

export default GridHeader;
